export default "__VITE_ASSET__DsV6vr3___"